import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AspWarrantyCertificateDetailsService } from './asp-warranty-certificate-details.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { S3ImageUploadService } from 'app/shared/s3-image-upload.service';
import { HttpClient } from '@angular/common/http';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { AfterViewChecked } from '@angular/core';


@Component({
  selector: 'app-asp-warranty-certificate-details',
  templateUrl: './asp-warranty-certificate-details.component.html',
  styleUrls: ['./asp-warranty-certificate-details.component.scss']
})
export class AspWarrantyCertificateDetailsComponent implements OnInit , AfterViewChecked {

  certificateId: any;
  warrantyDetails: any;
  orderKey: any;
  packageId: any;
  showWarrantyUI: boolean = false; 
  showCertificateUI: boolean = true;
  customerName: string;
  garageName: string;
  purchaseDate: any;
  packageName: any;
  packageNumber: any;
  kmLimit: any;
  certificateNumber: any;
  validTill: any;
  selectedPackage: any;
  shipmentNumber: any;
  userMobile: any;
  registrationNumber: any;
  termsAndConditionList: any;
  loading: boolean = false;
  private scrollToTopWarranty: boolean = false;
  private scrollToTopCertificate: boolean = false;
  make: any;
  model: any;
  variant: any;
  fuelType: any;
  mfgYear: any;
  constructor(
    private route: ActivatedRoute,
    private warrantyService: AspWarrantyCertificateDetailsService,
    private s3ImageUploadService: S3ImageUploadService,
    private http: HttpClient,
    private aspLoadingService: AspLoadingService,
  ) {}

  ngOnInit(): void {
      this.orderKey = this.route.snapshot.paramMap.get('orderKey');
      this.packageId = this.route.snapshot.paramMap.get('packageId');
      // console.log("Received OrderKey:", this.orderKey);
      this.garageName = localStorage.getItem('spareSelectedGarageName') || 'Garage';

      if(this.orderKey) {
          this.loadWarrantyDetails(this.orderKey, this.packageId); // ✅ Pass the correct key
      } else {
          console.error("OrderKey is missing in route!");
      }
  }

  loadWarrantyDetails(orderKey: any, packageId: any) {
    // console.log("----- loadWarrantyDetails called -----");
    this.aspLoadingService.show();

    this.warrantyService.getWarrantyDetails(orderKey, packageId).subscribe({
      next: (res: any) => {
          this.aspLoadingService.hide();
        // console.log("Warranty Details Response:", res);

        this.warrantyDetails = res?.data;
        this.make   = this.warrantyDetails?.make || '';
        this.model  = this.warrantyDetails?.model || '';
        this.mfgYear = this.warrantyDetails?.mfgYear || '';
        this.variant = this.warrantyDetails?.variant || '';
        this.fuelType = this.warrantyDetails?.fuelType || '';

        // ⭐ Extract FIRST item from packageDetails array
        const pkg = this.warrantyDetails?.packageDetails?.[0];
        this.selectedPackage = pkg;
        if (!pkg) {
          console.error("No package details found!");
          return;
        }

        // ⭐ Now assign your fields
        this.customerName = pkg.userName || '';
        this.purchaseDate = pkg.packageDate || '';
        this.validTill = pkg.validTill || pkg.ValidTill || '';
        this.kmLimit = pkg.odometerKm || '';
        this.packageName = pkg.name || '';
        this.certificateNumber = pkg.certificateNumber || '';
        this.packageNumber = pkg.packageNumber || '';
        this.shipmentNumber = pkg.shipmentNumber || '';
        this.userMobile = pkg.userMobile || '';
        this.registrationNumber = pkg.registrationNumber || '';
        this.termsAndConditionList = this.warrantyDetails?.termsAndCondition
          ? this.warrantyDetails.termsAndCondition.split('\n')
          : [];

        this.warrantyDetails.orderItems = (pkg.items || []).map((item: any) => ({
        partName: item.name || 'N/A',
        partNumber: item.partNumber || 'N/A',
        brandName: item.brandName || 'N/A',
        quantity: item.quantity || 0,
        packageId: item.packageId || null
      }));
      },

      error: (err) => {
        console.error("Error loading warranty details:", err);
      }
    });
  }

toggleWarrantyUI() {
    this.showWarrantyUI = !this.showWarrantyUI;
    this.showCertificateUI = false;
    this.scrollToTopWarranty = true; 
  }

  toggleCertificateUI() {
    this.showCertificateUI = true;
    this.showWarrantyUI = false;
    this.scrollToTopCertificate = true; // request scroll
  }

  ngAfterViewChecked(): void {
    if (this.scrollToTopWarranty) {
      this.scrollToTopWarranty = false;
      this.scrollContainerToTop();
    }
    if (this.scrollToTopCertificate) {
      this.scrollToTopCertificate = false;
      this.scrollContainerToTop();
    }
  }

  private scrollContainerToTop() {
    const container = document.querySelector<HTMLElement>('.page-layout');
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

//   downloadCertificatePDF() {
//   const elementToPrint: any = document.getElementById('certificateDiv');

//   html2canvas(elementToPrint, {
//     scale: 2,    // improve quality
//     useCORS: true
//   }).then(canvas => {
//     const imgData = canvas.toDataURL('image/png');

//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pdfWidth = 210; // A4 width in mm
//     const pdfHeight = 297; // A4 height in mm

//     // calculate image height to fit A4 width
//     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

//     if (imgHeight <= pdfHeight) {
//       // fits in one page
//       pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, imgHeight);
//     } else {
//       // content exceeds one page, split into multiple pages
//       let position = 0;
//       let remainingHeight = canvas.height;
//       const pageHeightInPx = (canvas.width * pdfHeight) / pdfWidth;

//       while (remainingHeight > 0) {
//         const canvasPage = document.createElement('canvas');
//         canvasPage.width = canvas.width;
//         canvasPage.height = Math.min(pageHeightInPx, remainingHeight);

//         const ctx = canvasPage.getContext('2d');
//         ctx?.drawImage(
//           canvas,
//           0,
//           position,
//           canvas.width,
//           canvasPage.height,
//           0,
//           0,
//           canvas.width,
//           canvasPage.height
//         );

//         const imgPageData = canvasPage.toDataURL('image/png');
//         pdf.addImage(imgPageData, 'PNG', 0, 0, pdfWidth, (canvasPage.height * pdfWidth) / canvas.width);

//         remainingHeight -= canvasPage.height;
//         position += canvasPage.height;

//         if (remainingHeight > 0) {
//           pdf.addPage();
//         }
//       }
//     }

//     pdf.save('Warranty-Certificate.pdf');
//   });
// }
downloadSinglePDFWithTwoDivs() {
  this.aspLoadingService.show();

  const certificateLink = this.selectedPackage?.certificateLink;

  if (!certificateLink) {
    console.error('Certificate link not available');
    this.aspLoadingService.hide();
    return;
  }

  const link = document.createElement('a');
  link.href = certificateLink;

  const regNo = (this.registrationNumber || 'REG-NO')
    .replace(/\s+/g, '')
    .toUpperCase();

  const wcId = this.selectedPackage?.certificateNumber || 'WC-ID';

  link.download = `${regNo}-${wcId}.pdf`;

  link.click();

  this.aspLoadingService.hide();
}
// async downloadSinglePDFWithTwoDivs() {
//   this.aspLoadingService.show();

//   // ✅ Save current UI state
//   const originalCertificateUI = this.showCertificateUI;
//   const originalWarrantyUI    = this.showWarrantyUI;

//   // ✅ Render both divs invisibly for capture
//   this.showCertificateUI = true;
//   this.showWarrantyUI    = true;

//   // Wait for DOM render
//   await new Promise(resolve => setTimeout(resolve, 300));

//   const div1: any = document.getElementById('certificateDiv');
//   const div2: any = document.getElementById('termsDiv');

//   if (!div1 || !div2) {
//     console.error('One or both divs not found!');
//     return;
//   }

//   const pdf = new jsPDF('p', 'mm', 'a4');

//   // ✅ Margin settings
//   const margin = 10;              // all sides (mm)
//   const pageWidth = 210;
//   const usableWidth = pageWidth - margin * 2;

//   // ---------- PAGE 1 ----------
//   const canvas1 = await html2canvas(div1, {
//     scale: 2,
//     useCORS: true
//   });

//   const img1 = canvas1.toDataURL('image/png');
//   const height1 = (canvas1.height * usableWidth) / canvas1.width;

//   pdf.addImage(
//     img1,
//     'PNG',
//     margin,
//     margin,
//     usableWidth,
//     height1
//   );

//   // ---------- PAGE 2 ----------
//   pdf.addPage();

//   const canvas2 = await html2canvas(div2, {
//     scale: 2,
//     useCORS: true
//   });

//   const img2 = canvas2.toDataURL('image/png');
//   const height2 = (canvas2.height * usableWidth) / canvas2.width;

//   pdf.addImage(
//     img2,
//     'PNG',
//     margin,
//     margin,
//     usableWidth,
//     height2
//   );

//   // ---------- SAVE PDF ----------
//   // pdf.save('Certificate-With-Terms.pdf');
//   // sanitize values just in case
//   const regNo = (this.registrationNumber || 'REG-NO').replace(/\s+/g, '').toUpperCase();
//   const wcId  = (this.certificateNumber || this.packageNumber || 'WC-ID');

//   // final filename
//   const fileName = `${regNo}-${wcId}.pdf`;

//   pdf.save(fileName);

//   this.aspLoadingService.hide();

//   // ✅ Restore original screen state
//   this.showCertificateUI = originalCertificateUI;
//   this.showWarrantyUI    = originalWarrantyUI;
// }

  
  capturePDF() {
    const certificateElement: any = document.getElementById('certificateDiv');
    const termsElement: any = document.getElementById('termsDiv');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210;

    html2canvas(certificateElement, { scale: 2, useCORS: true }).then(certificateCanvas => {
      const certificateImgHeight = (certificateCanvas.height * imgWidth) / certificateCanvas.width;
      const certificateImgData = certificateCanvas.toDataURL('image/png');
      pdf.addImage(certificateImgData, 'PNG', 0, 0, imgWidth, certificateImgHeight);

      html2canvas(termsElement, { scale: 2, useCORS: true }).then(termsCanvas => {
        const termsImgHeight = (termsCanvas.height * imgWidth) / termsCanvas.width;
        const termsImgData = termsCanvas.toDataURL('image/png');
        pdf.addPage();
        pdf.addImage(termsImgData, 'PNG', 0, 0, imgWidth, termsImgHeight);

        pdf.save('Certificate-And-Terms.pdf');
        // Optionally hide the certificate again
        this.showCertificateUI = false;
      });
    });
  }

//   generateCertificatePDF(): Promise<Blob> {
//     return new Promise((resolve, reject) => {
//       const element = document.getElementById('certificateDiv');

//       html2canvas(element!, { scale: 2, useCORS: true }).then(canvas => {
//         const imgWidth = 210;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;

//         const imgData = canvas.toDataURL('image/png');

//         const pdf = new jsPDF('p', 'mm', 'a4');
//         pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

//         const pdfBlob = pdf.output("blob");
//         resolve(pdfBlob);
//       }).catch(err => reject(err));
//     });
//   }
//   uploadCertificateToS3(pdfBlob: Blob): Promise<string> {
//   return new Promise((resolve, reject) => {

//     const fileName = `warrantycertificate_${Date.now()}.pdf`;

//     this.s3ImageUploadService.getPresignedUrl(fileName).subscribe({
//       next: (response) => {

//         const presignedUrl = response[0]?.signedUrl;
//         const fileLink = response[0]?.link;  // <<— THIS IS WHAT YOU WANT

//         if (!presignedUrl || !fileLink) {
//           reject("Invalid presigned URL response");
//           return;
//         }

//         // Upload PDF to S3
//         this.http.put(presignedUrl, pdfBlob, {
//           headers: { 'Content-Type': 'application/pdf' }
//         }).subscribe({
//           next: () => {
//             // Return the link from API response
//             resolve(fileLink);  
//           },
//           error: (err) => reject(err)
//         });
//       },
//       error: (err) => reject(err)
//     });

//   });
// }

async shareOnWhatsApp() {
  try {
    this.aspLoadingService.show();
    // const pdfBlob = await this.generateCertificatePDF();
    // const pdfLink = await this.uploadCertificateToS3(pdfBlob);
    const pdfLink = this.selectedPackage?.certificateLink;

    const customerName = this.toTitleCase(this.customerName || "Customer");
    const garageName = this.toTitleCase(this.garageName || "Garage");

    const message =
`*🎉 Your Warranty Certificate is Here! 🎉*

Thank you for trusting *${garageName}* for your vehicle service. We believe in quality, transparency and genuine parts.

We have issued a *Premium Digital Warranty Certificate* for the spare parts used in your vehicle. This certificate is backed by *Autoverse – India’s Trusted Genuine Parts Partner*, giving you complete peace of mind.

📜 Click below to view your certificate 👇
${pdfLink}

✔ Genuine parts
✔ Warranty proof in writing
✔ Professional documentation

If you ever need support, just share this certificate with us – we’ll take care of the rest.

Thank you for choosing us and driving with confidence! 🚗💛

-Team *${garageName}*
Powered by *Autoverse*`; 

    const encodedMsg = encodeURIComponent(message);
    const waUrl = `https://api.whatsapp.com/send?text=${encodedMsg}`;

    window.open(waUrl, "_blank");

  } catch (error) {
    console.error("Error sharing warranty certificate:", error);
  } finally {
    // Hide loading
    this.aspLoadingService.hide();
  }
}
//   generateTermsPDF(): Promise<Blob> {
//     return new Promise((resolve, reject) => {
//       const element = document.getElementById('termsDiv');

//       html2canvas(element!, { scale: 2, useCORS: true }).then(canvas => {
//         const imgWidth = 210;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;

//         const imgData = canvas.toDataURL('image/png');

//         const pdf = new jsPDF('p', 'mm', 'a4');
//         pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

//         const pdfBlob = pdf.output("blob");
//         resolve(pdfBlob);

//       }).catch(err => reject(err));
//     });
//   }
//   uploadTermsToS3(pdfBlob: Blob): Promise<string> {
//     return new Promise((resolve, reject) => {

//       const fileName = `termsandconditions_${Date.now()}.pdf`;

//       this.s3ImageUploadService.getPresignedUrl(fileName).subscribe({
//         next: (response) => {

//           const presignedUrl = response[0]?.signedUrl;
//           const fileLink = response[0]?.link;

//           if (!presignedUrl || !fileLink) {
//             reject("Invalid presigned URL response");
//             return;
//           }

//           this.http.put(presignedUrl, pdfBlob, {
//             headers: { 'Content-Type': 'application/pdf' }
//           }).subscribe({
//             next: () => resolve(fileLink),
//             error: (err) => reject(err)
//           });

//         },
//         error: (err) => reject(err)
//       });
//     });
//   }
// async shareTermsOnWhatsApp() {
//   try {
//     this.aspLoadingService.show();
//     const pdfBlob = await this.generateTermsPDF();
//     const pdfLink = await this.uploadTermsToS3(pdfBlob);
//     const customerName = this.customerName || "Customer";
//     const garageName = this.garageName || "Garage";

//      const message =
// `*🎉 Terms & Conditions 🎉*

// Thank you for trusting *${garageName}* for your vehicle service. We believe in quality, transparency and genuine parts.

// We have issued a *Premium Digital Warranty Certificate* for the spare parts used in your vehicle. This certificate is backed by *Autoverse – India’s Trusted Genuine Parts Partner*, giving you complete peace of mind.

// 📜 Click below to view your certificate 👇
// ${pdfLink}

// ✔ Genuine parts
// ✔ Warranty proof in writing
// ✔ Professional documentation

// If you ever need support, just share this certificate with us – we’ll take care of the rest.

// Thank you for choosing us and driving with confidence! 🚗💛

// -Team *${garageName}*
// Powered by *Autoverse*`; 

//     const encodedMsg = encodeURIComponent(message);
//     const waUrl = `https://api.whatsapp.com/send?text=${encodedMsg}`;

//     window.open(waUrl, "_blank");

//   } catch (error) {
//     console.error("Error sharing Terms & Conditions:", error);
//   } finally {
//     this.aspLoadingService.hide();
//   }
// }


  //  CHANGED HERE – new helper function for Title Case formatting
  toTitleCase(text: string): string {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  getFormattedRegNo(regNo: string): string {
    if (!regNo) return '';
    // Assuming regNo is like 'KA03MX6069'
    return regNo.replace(/^([A-Z]{2})(\d{2})([A-Z]{2})(\d{4})$/, '$1 $2 $3 $4');
  }
get brandedWarrantyItems() {
  return this.warrantyDetails?.packageDetails?.[0]?.items?.filter(
    item => item.brandName && item.brandName.trim() !== ''
  ) || [];
}

}
